<div class="zk-flex zk-gap-1 zk-items-center zk-pb-2">
	<div class="title">{{ title }}</div>
	<div *ngIf="helperTooltip" freud-tooltip [tooltipLabel]="helperTooltip">
		<span class="freud-icon freud-icon-alert-circle"></span>
	</div>
</div>
<div class="speech-to-text" *ngIf="canRecordWithSpeechToText">
	<speech-to-text (recording)="recordingSpeechToText($event)"></speech-to-text>
</div>
<textarea
	#nativeTextArea
	[id]="'auto-save-' + property"
	[maxLength]="maxLength"
	placeholder="{{ placeholder }}"
	[(ngModel)]="inputValue?.length ? inputValue + '\n' + inputValueSpeechToText : inputValue + inputValueSpeechToText"
	(input)="updateText($event.target.value)"
	[disabled]="speechToTextIsRecording"
	[rows]="rows"
	[ngClass]="(rows && rows > 0) ? '' : 'min-height'"
></textarea>
<div class="zk-flex zk-justify-between zk-mt-2">
	<div class="char-counter">{{ charCount }}/{{ maxLength }}</div>
</div>
<service-evolution-quality-banner *ngIf="showQuality" mode="input" [quality]="quality"></service-evolution-quality-banner>
<div class="footer" *ngIf="status != 'default'">
	<div class="last-update" *ngIf="edited">
		{{ 'TEXTAREA.LAST_EDIT' | translate: { minutes: lastEditedMinutes } }}
	</div>

	<div class="status" *ngIf="status === 'saving'">
		{{ 'TEXTAREA.SAVING' | translate }}
		<freud-loader size="sm" [bgColor]="false"></freud-loader>
	</div>

	<div
		class="status"
		*ngIf="status === 'saved'"
		pTooltip="{{ 'TEXTAREA.INFO' | translate }}"
		tooltipPosition="top"
	>
		{{ 'TEXTAREA.SAVED' | translate }}
		<span class="freud-icon freud-icon-circle-check freud-icon-md"></span>
	</div>

	<div class="status" *ngIf="status === 'error'">
		{{ 'TEXTAREA.ERROR' | translate }}
	</div>
</div>
